import { AiResult, StructuredSummaryResult, StructuredSummaryResultType } from '../../../../../../../models/AiResult'
import { useEffect, useState } from 'react'
import { isArray, isObject } from '../../../../../../../common/util'
export interface ConversationTimelineResult {
  topic: string
  percentage: string
}

interface ConversationTimelineResultDetails {
  displayMode: 'default' | 'custom'
  results: ConversationTimelineResult[]
  mostPopularResult: ConversationTimelineResult | null
}

export const useConversationTimelineResult = (aiResult: AiResult): ConversationTimelineResultDetails => {
  const [displayMode, setDisplayMode] = useState<'default' | 'custom'>('default')
  const [conversationTimelineResults, setConversationTimelineResults] = useState<ConversationTimelineResult[]>([])
  const [mostPopularConversationTimelineResult, setMostPopularConversationTimelineResult] = useState<ConversationTimelineResult | null>(null)
  useEffect(() => {
    if (aiResult.result) {
      const structuredSummaryResult = aiResult.result as StructuredSummaryResult
      if (!isArray(structuredSummaryResult.result)) {
        setDisplayMode('default')
        return
      }
      setDisplayMode('custom')
      const mappedResults = (structuredSummaryResult.result as StructuredSummaryResultType[])
        .map((result) => {
          if (isObject(result)) {
            const objectResult = result as { [key: string]: StructuredSummaryResultType | StructuredSummaryResultType[] }
            const topic = objectResult.Topic || objectResult.topic
            const percentage = objectResult.Percentage || objectResult.percentage
            if (topic && percentage) {
              return {
                topic: topic,
                percentage: percentage,
              } as ConversationTimelineResult
            }
          }
          return null
        })
        .filter((result): result is ConversationTimelineResult => !!result)
      const mostPopular = mappedResults.reduce((prev: ConversationTimelineResult | null, curr) => {
        try {
          const currPercentage = parseInt(curr.percentage.split('%')[0])
          const prevPercentage = prev ? parseInt(prev.percentage.split('%')[0]) : 0
          if (!prev || currPercentage > prevPercentage) {
            return curr
          }
        } catch (e) {}
        return prev
      }, null)
      setMostPopularConversationTimelineResult(mostPopular)
      setConversationTimelineResults(mappedResults)
    }
  }, [aiResult])

  return { displayMode, results: conversationTimelineResults, mostPopularResult: mostPopularConversationTimelineResult }
}
